import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import { customerContactBusiness } from "api/bussiness/customer/customer-contact-bussiness";
import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { rolePermissionsBusiness } from "api/bussiness/user-role-permission/role-permission-bussiness";
import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { Pagination } from "api/models/response/pagination";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import { cast, flow, types } from "mobx-state-tree";
import { Catalogue, ICatalogue } from "mobx-stores/_models/base";
import { IRoleProperties, Role } from "mobx-stores/_models/user-roles/role";

export const CatalogueStore = types
  .model({
    roles: types.maybeNull(types.array(Role)),
    customerTypes: types.maybeNull(types.array(Catalogue)),
    departmentTypes: types.maybeNull(types.array(Catalogue)),
    orderStatuses: types.maybeNull(types.array(Catalogue)),
    workOrderPoStatuses: types.maybeNull(types.array(Catalogue)),
  })
  .views((self) => ({
    get rolesAsOptionItems(): OptionItem[] {
      return self.roles != null
        ? self.roles.map((x) => ({
            value: x.name || "",
            label: x.name || "",
          }))
        : [];
    },
  }))
  .actions((self) => ({
    getRoles: flow(function* getRolesList(refresh: boolean = true) {
      try {
        if (refresh || self.roles == null) {
          const res =
            (yield rolePermissionsBusiness.getRoleList()) as Pagination<IRoleProperties>;
          self.roles = cast(res.items);
        }
      } catch {
        self.roles = null;
      }
    }),
    getCustomerTypes: flow(function* getCustomerTypes(
      refresh: boolean = false,
    ) {
      try {
        if (refresh || self.customerTypes == null) {
          const res =
            (yield customerBusiness.getCustomerType()) as Pagination<ICatalogue>;
          self.customerTypes = cast(res.items);
        }
      } catch {
        self.customerTypes = null;
      }
    }),
    getDepartmentTypes: flow(function* getDepartmentTypes(
      refresh: boolean = false,
    ) {
      try {
        if (refresh || self.departmentTypes == null) {
          const res =
            (yield customerContactBusiness.getDepartmentType()) as Pagination<ICatalogue>;
          self.departmentTypes = cast(res.items);
        }
      } catch {
        self.departmentTypes = null;
      }
    }),
    getOrderStatuses: flow(function* getOrderStatuses(
      refresh: boolean = false,
    ) {
      try {
        if (refresh || self.orderStatuses == null) {
          const res =
            (yield orderBusiness.getOrderStatuses()) as Pagination<ICatalogue>;
          self.orderStatuses = cast(res.items);
        }
      } catch {
        self.orderStatuses = null;
      }
    }),
    getWorkOrderPoStatuses: flow(function* getWorkOrderPoStatuses(
      refresh: boolean = false,
    ) {
      try {
        if (refresh || self.workOrderPoStatuses == null) {
          const res =
            (yield workOrderPoBusiness.getWorkOrderPoStatuses()) as Pagination<ICatalogue>;
          self.workOrderPoStatuses = cast(res.items);
        }
      } catch {
        self.workOrderPoStatuses = null;
      }
    }),
  }))
  .actions((self) => ({
    cataloguesToOptionItems: (catalogues: ICatalogue[]) => {
      const options = catalogues.map((x) => x.toOptionItem());
      return options || [];
    },
    defaultOptionItem: (catalogues: ICatalogue[]) => {
      const option = catalogues?.[0].toOptionItem();
      return option || null;
    },
  }));
